

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.ProcessingStatus = (function () {

    function ProcessingStatus() {

        this.rootEl = document.createElement("div");
        this.rootEl.className = "textfile-processing";
        this.listEl = document.createElement("div");
        this.listEl.className = "textfile-processing-list";
        this.listItems = {};
        this.timeout = null;

        this.getList = function (fn, error) {
            var ajax = new Monet.Ajax();
            ajax.url = "Process/Progress/ListRunning";
            ajax.method = "GET";
            ajax.success = fn;
            if (error) {
                ajax.error = error;
            }
            ajax.send();
        };

        this.getProcessProgress = (processId) => new Promise((resolve, reject) => {
            const data = `{"firstResult":0,"maxResults":1,"processId":"${processId}"}`;
            const request = new Monet.Ajax();
            request.url = `/Process/ProgressAndErrors`;
            request.method = 'post';
            request.data = data;
            request.success = resolve;
            request.error = reject;
            request.send();
        });

        this.cancelProcess = (processId) => new Promise((resolve, reject) => {
            const request = new Monet.Ajax();
            request.url = `/Process/${processId}/Cancel`;
            request.method = 'post';
            request.success = resolve;
            request.error = reject;
            request.send();
        });

        this.renderFeedback = function (type, messageTitleText, messageBodyText) {
            const feedbacksDiv = document.getElementById("textfile-cancel-feedbacks");
            const feedback = document.createElement("div");
            feedback.classList.add("textfile-cancel-feedback");
            const feedbackTitle = document.createElement("p");
            feedbackTitle.classList.add("feedback-title");
            const feedbackBody = document.createElement("p");
            feedbackBody.classList.add("feedback-body");

            const closeButton = document.createElement("span");
            closeButton.classList.add("close-button");
            const closeText = document.createTextNode("×");
            closeButton.appendChild(closeText);
            closeButton.setAttribute('title', "Fechar");
            closeButton.addEventListener("click", function () {
                this.parentNode.parentNode.removeChild(this.parentNode);
            });
            feedback.appendChild(closeButton);

            if (type === "success") {
                feedback.classList.add("feedback-success");
            } else {
                feedback.classList.add("feedback-error");
            }

            const messageTitle = document.createTextNode(messageTitleText);

            feedbackTitle.appendChild(messageTitle);
            feedback.appendChild(feedbackTitle);

            if (messageBodyText) {
                const messageBody = document.createTextNode(messageBodyText);
                feedbackBody.appendChild(messageBody);
                feedback.appendChild(feedbackBody);
            }

            feedbacksDiv.appendChild(feedback);

            setTimeout(function () {
                if (feedback && feedback.parentNode) {
                    feedback.parentNode.removeChild(feedback);
                }
            }, 10000);
        }

        this.getProcessProgressAndRenderFeedback = (processId) => {
            let alreadyCompleted = false;
            let wasCanceled = false;
            let cancelError = false;
            let hasProgress = false;
            this.getProcessProgress(processId)
                .then(data => {
                    const progress = data.progress || {};
                    const processedItems = progress && progress.processedItems || 0;
                    const totalItems = progress && progress.totalItems || 0;
                    const totalProgress = (processedItems / totalItems);
                    if (totalProgress === 1) {
                        alreadyCompleted = true;
                    } else {
                        hasProgress = totalProgress > 0;
                        return this.cancelProcess(processId)
                            .then(result => {
                                if (result) {
                                    wasCanceled = true;
                                } else {
                                    cancelError = true;
                                }
                            });
                    }
                })
                .catch(err => {
                    cancelError = err;
                })
                .finally(() => {
                    let messageType;
                    let messageTitle;
                    let messageBody;
                    if (alreadyCompleted) {
                        messageType = 'error';
                        messageTitle = Monet.I18n.getResourcesByKey('textfile.processing.error');
                        messageBody = Monet.I18n.getResourcesByKey('textfile.processing.importCompleted');
                    } else if (wasCanceled) {
                        messageType = 'success';
                        messageTitle = Monet.I18n.getResourcesByKey('textfile.processing.canceled');
                        if (hasProgress) {
                            this.getProcessProgress(processId)
                                .then(data => {
                                    const progress = data.progress || {};
                                    const processedItems = progress && progress.processedItems || 0;
                                    const totalItems = progress && progress.totalItems || 0;
                                    const totalProgress = (processedItems / totalItems);
                                    const percentValue = (parseFloat(totalProgress) * 100).toFixed(0);
                                    messageBody = Monet.I18n.getResourcesByKey('textfile.processing.percentageImported', percentValue);
                                }).finally(() => {
                                    this.renderFeedback(messageType, messageTitle, messageBody);
                                });
                            return;
                        }
                    } else if (cancelError) {
                        messageType = 'error';
                        messageTitle = Monet.I18n.getResourcesByKey('textfile.processing.cancel.error');
                    }
                    this.renderFeedback(messageType, messageTitle, messageBody);

                    const listItemParent = document.querySelector('.textfile-processing-list');
                    const listItem = document.querySelector('.textfile-processing-item');
                    listItemParent.removeChild(listItem);
                });
        }

        this.handleClickOnCancelImportLogsBtn = (processId) => {
            this.getProcessProgressAndRenderFeedback(processId);
        }

        this.addListenersToCancelImportLogsBtn = function (btn, processId) {
            btn.addEventListener('click', () => {
                this.handleClickOnCancelImportLogsBtn(processId);
            });
        }

        this.handleClickOnSeeLogsBtn = function (event) {
            const btn = event.target || {};
            if (btn.processId && btn.fileName) {
                window.location.href = `#DataImport/SeeLogs/${btn.processId}/${encodeURI(btn.fileName)}`;
            }
        }

        this.addListenersToSeeLogsBtn = function (btn, item) {
            btn.processId = item.processId;
            btn.fileName = item.fileName;
            btn.addEventListener('click', this.handleClickOnSeeLogsBtn);
        }

        this.renderItem = function (item) {

            var listItem = document.createElement("div"),
                icon = document.createElement("i"),
                right = document.createElement("div"),
                topName = document.createElement("div"),
                name = document.createElement("span"),
                seeLogs = document.createElement("a"),
                cancelImportLogs = document.createElement("a"),
                progressContainer = document.createElement("div"),
                progressValue = document.createElement("div"),
                percent = document.createElement("span"),
                percentValue = (parseFloat(item.totalProgress) * 100).toFixed(0) + "%";

            listItem.className = "textfile-processing-item";
            icon.className = "textfile-processing-icon fa fa-file " + (item.errors ? "errors" : "");
            right.className = "textfile-processing-right";
            topName.className = "textfile-processing-topname";
            name.className = "textfile-processing-filename";
            name.innerHTML = item.fileName;
            seeLogs.className = "textfile-processing-seelogs";
            seeLogs.innerHTML = Monet.I18n.getResourcesByKey("Greenmile.DataImport.seeLogs");
            cancelImportLogs.className = "textfile-processing-cancel-import-logs";
            cancelImportLogs.innerHTML = Monet.I18n.getResourcesByKey("Greenmile.DataImport.cancel.ImportLog").toLowerCase();
            percent.className = "textfile-processing-percent";
            percent.innerHTML = percentValue;

            progressValue.style.width = percentValue;
            progressContainer.className = 'progressbar';
            progressValue.className = 'value';
            progressContainer.appendChild(progressValue);

            listItem.appendChild(icon);
            topName.appendChild(name);
            topName.appendChild(cancelImportLogs);
            topName.appendChild(seeLogs);

            this.addListenersToCancelImportLogsBtn(cancelImportLogs, item.processId);

            seeLogs.addEventListener("click", function () {
                window.location.href = `#DataImport/SeeLogs/${item.processId}/${encodeURI(item.fileName)}`;
            });
            right.appendChild(topName);
            right.appendChild(progressContainer);
            right.appendChild(percent);

            listItem.appendChild(right);

            this.listItems[item.processId] = {
                rootEl: listItem,
                progress: progressValue,
                percent: percent,
                icon: icon
            };

            return this.listItems[item.processId].rootEl;
        };

        this.renderList = function (list) {

            if (!list || !list.length) {
                this.renderNoData();
                this.updater();
                return;
            }

            this.removeNoData();

            var fragment = document.createDocumentFragment();

            list.forEach(function (item) {
                fragment.appendChild(this.renderItem(item));
            }.bind(this));

            this.listEl.appendChild(fragment);
        };

        this.insertItem = function (item) {
            if (this.listEl.childNodes[0]) {
                this.listEl.insertBefore(this.renderItem(item), this.listEl.childNodes[0]);
            } else {
                this.listEl.appendChild(this.renderItem(item));
            }
        };

        this.updateItem = function (item) {
            if (!this.listItems[item.processId]) {
                return;
            }

            var listItem = this.listItems[item.processId],
                percentValue = (parseFloat(item.totalProgress) * 100).toFixed(0) + "%";

            listItem.progress.style.width = percentValue;
            listItem.percent.innerHTML = percentValue;

            if (item.totalProgress === 1) {
                const cancelButton = listItem.rootEl.querySelector('.textfile-processing-cancel-import-logs');
                if (cancelButton)
                    cancelButton.parentNode.removeChild(cancelButton);
            }
        };

        this.renderNoData = function () {
            this.listEl.innerHTML = "";
            var noData = document.createElement("div");
            noData.innerHTML = Monet.I18n.getResourcesByKey("DataImport.no.processRunning");
            noData.className = "noProcess";
            this.listEl.appendChild(noData);
        };

        this.removeNoData = function () {
            var process = this.listEl.querySelector(".noProcess");
            if (process) {
                process.parentNode.removeChild(process);
            }
        };

        this.update = function () {
            this.getList(function (data) {

                if (!data || !data.length) {
                    this.renderNoData();
                    this.updater();
                    return;
                }

                this.removeNoData();

                var listItemsKeys = Object.keys(this.listItems);

                var remoteProcessIds = data.map(function (item) {
                    return item.processId;
                });

                var removeList = listItemsKeys.filter(function (item) {
                    return remoteProcessIds.indexOf(parseInt(item)) === -1;
                });

                var addList = remoteProcessIds.filter(function (item) {
                    return listItemsKeys.indexOf(item.toString()) === -1;
                }.bind(this));

                removeList.forEach(function (item) {
                    var remove = this.listItems[parseInt(item)].rootEl;
                    if (remove.parentNode) {
                        remove.parentNode.removeChild(remove);
                    }

                    delete this.listItems[parseInt(item)];
                }.bind(this));

                data.forEach(function (item) {
                    this.updateItem(item);
                }.bind(this));

                data.filter(function (item) {
                    return addList.indexOf(item.processId) !== -1;
                }).forEach(function (item) {
                    this.insertItem(item);
                }.bind(this));

                this.updater();
            }.bind(this), this.updater);
        };

        this.updater = function () {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                this.update();
                console.log("[DataImport] Update");
            }.bind(this), 10000);
        };

        this.updateNow = function () {
            clearTimeout(this.timeout);
            this.update();
        };

        this.render = function () {
            var title = document.createElement("div");
            title.className = "textfile-processing-title";
            title.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey("textfile.processing.title")));

            const feedbacks = document.createElement("div");
            feedbacks.setAttribute("id", "textfile-cancel-feedbacks");

            this.rootEl.appendChild(title);
            this.rootEl.appendChild(feedbacks);
            this.rootEl.appendChild(this.listEl);

            this.getList(function (data) {
                this.renderList(data);
                this.updater();
            }.bind(this), this.updater);

            return this.rootEl;
        };

    }

    return ProcessingStatus;
}());
